module.exports = __webpack_public_path__ + "static/media/kitchen1.ec0c827e.png";